import { useTranslation } from 'react-i18next';

interface Props {
  refCode: string;
  onReset: () => void;
}

export function SuccessPage({ refCode, onReset }: Props) {
  const { t } = useTranslation();

  return (
    <div className="success-page">
      <div className="success-icon">✓</div>
      <h2 className="success-title">{t('success.title')}</h2>
      <p className="success-message">{t('success.message')}</p>

      <div className="ref-code">
        <div className="ref-code-label">{t('success.refCode')}</div>
        <div>{refCode}</div>
      </div>

      <p className="success-message" style={{ fontSize: '13px' }}>
        {t('success.emailNote')}
      </p>

      <button className="submit-another-btn" onClick={onReset}>
        {t('success.submitAnother')}
      </button>
    </div>
  );
}
